import axios from "axios";
import { POSTPAYMENTINTENT, INSERTPAYMENTAMOUNT } from "../index";

export const getPaymentIntentId = (postData) => {
  return axios.post(POSTPAYMENTINTENT, JSON.stringify(postData));
};

export const insertPaymentAmount = (postAmt) => {
  return axios.post(INSERTPAYMENTAMOUNT, JSON.stringify(postAmt));
};